import { render, staticRenderFns } from "./ChatBot copy 2.vue?vue&type=template&id=7ddeec04&scoped=true&"
import script from "./ChatBot copy 2.vue?vue&type=script&lang=js&"
export * from "./ChatBot copy 2.vue?vue&type=script&lang=js&"
import style0 from "./ChatBot copy 2.vue?vue&type=style&index=0&id=7ddeec04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddeec04",
  null
  
)

export default component.exports